import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var createNewSoSlice = createSlicePrototype({
    name: "createNewSo"
});
export var createNewSo = createFetchLogicPrototype({
    actions: createNewSoSlice.actions,
    configFn: function(param, param1) {
        var payload = param.payload, accessToken = param1.accessToken;
        return {
            method: "post",
            url: "".concat(endPoint.NEW_SO),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            },
            data: payload
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearCreateNewSo = function() {
    return function(dispatch) {
        dispatch(createNewSoSlice.actions.resetState());
    };
};
var _createNewSoSlice_actions = createNewSoSlice.actions;
export var fetchData = _createNewSoSlice_actions.fetchData, fetchDataSuccess = _createNewSoSlice_actions.fetchDataSuccess, fetchDataFailure = _createNewSoSlice_actions.fetchDataFailure, resetState = _createNewSoSlice_actions.resetState;
export default createNewSoSlice.reducer;
